module.exports = __webpack_public_path__ + "static/images/i-video.68ce64d.png";